<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-text-field v-model="currentItem.product_code" label="Mã sản phẩm"
                            class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-text-field v-model="currentItem.staff_name" label="Người tạo"
                            class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-textarea v-model="currentItem.note" label="Ghi chú"
                            class="input-group--focused"></v-textarea>
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2>
                        <v-btn class="ma-2" color="indigo" dark @click="(dialogUpload = true)"><v-icon
                                dark>upload</v-icon></v-btn>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-layout row wrap class="images"  v-viewer="options">
                            <template v-for="(f, index) in currentItem.images">
                                <div class="attach-image mr-4" v-bind:key="f.id">
                                    <img style="width: 64px; height: 64px;" :src="f.path" :key="f.id">
                                    <v-btn color="red" icon x-small @click="fileRemove(index)"><v-icon>fas fa-times-circle</v-icon></v-btn>
                                </div>
                            </template>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
        <upload-file :dialogUpload="dialogUpload" :file_types="'.png, .jpg, .jpeg'" title="Tải file hình ảnh" @closePopup="dialogUpload = false" @importFile="uploadFile"></upload-file>
    </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import upload_file from "@/components/popups/upload_file";
export default {
    components: {
        "upload-file": upload_file
    },
    data() {
        return {
            options: {
            inline: false,
            button: true,
            navbar: true,
            title: 2,  // show if screen > 768px
            toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            oneToOne: 1,
            reset: 1,
            prev: 1,
            play: {
                show: 1,
                size: 'large',
            },
            next: 1,
            rotateLeft: 1,
            rotateRight: 1,
            flipHorizontal: 1,
            flipVertical: 1,
            },
            tooltip: true,
            movable: true,
            zoomable: true,
            rotatable: true,
            scalable: true,
            transition: true,
            fullscreen: true,
            keyboard: true,
        },
            dialogUpload: false,
            formData: null
        }
    },
    computed: {
        ...mapState({
            loading: state => state.products.loading,
            currentItem: state => state.products.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        is_admin() {
            return this.$store.state.authentication.user.is_admin;
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("products/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("products/setDetail", {
                    data: {
                        id: 0
                    }
                })
            }
        },
        saveData() {
            if(!this.is_admin) {
                sendErrorNotice('Bạn không có quyền chỉnh sửa & tạo mới sản phẩm');
                return;
            }
            this.$store.dispatch("products/setDetail", {
                data: {
                    ...this.currentItem,
                },
                id: this.currentItem.id
            }).then(p => {
                if (this.formData) {
                    this.formData.append('product_id', this.currentItem.id || p.data.id);
                    this.$store.dispatch("commons/upload_media_file", this.formData);
                    this.formData = null;
                }
                if(!this.currentItem.id) {
                    this.$router.push({
                        name: "ProductDetail",
                        params: {
                            Pid: id,
                            title: `Chi tiết sản phẩm (#${p.data.id})`
                        }
                    });
                }
                
            });
        },
        uploadFile(filelist) {
            this.formData = new FormData();
            filelist.forEach((file) => {
                this.formData.append(`images[]`, file); // Tên tham số là "images"
            });
            this.dialogUpload = false;
        },
        fileRemove(index) {
            this.currentItem.images.splice(index, 1);
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    },
};
</script>
<style type="text/css" scoped>
.attach-image {
    position: relative;
    width: 64px;
}

.attach-image button {
    position: absolute;
    right: 0;
    top: 0;
}

.attach-image .v-image {
    cursor: pointer;
}
</style>
